import { z } from 'zod';
/** Dossier sections — each is autosaved independently into dossier_forms.data_jsonb. */
export const dossierSectionSchema = z.enum([
    'applicant',
    'household',
    'income',
    'assets',
    'liabilities',
    'property',
    'employment',
    'documents',
    'review',
]);
/**
 * Autosave payload for one section. The section's fields are intentionally open
 * (stored as JSONB); the backend validates structural bounds, not every field,
 * so the portal can evolve form fields without a migration.
 *
 * `section` documents the full payload; the endpoint takes it from the path and
 * parses the body with `.omit({ section: true })`.
 */
export const dossierAutosaveSchema = z.object({
    section: dossierSectionSchema,
    /** Section form values. Bounded to keep payloads sane. */
    data: z.record(z.string(), z.unknown()),
    /** Client's last-edit timestamp for last-writer-wins conflict handling. */
    clientUpdatedAt: z.string().datetime().optional(),
    /**
     * Whether the client considers this section complete. OPTIONAL, and
     * deliberately WITHOUT `.default(false)`: this is an autosave (PUT, upsert),
     * and in Zod 4 `.omit()` does NOT strip a field's `.default()` — so the body
     * schema the controller derives would inject `completed: false` for every
     * caller that sends data only, silently DE-completing a finished section.
     * Same root cause as the #353 sweep; this endpoint was its last open case.
     *
     * Omitted now means "leave unchanged" on update and `false` on first create,
     * mirroring the sibling autosave `checklistSectionUpsertSchema`.
     */
    completed: z.boolean().optional(),
});
